import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output,
	inject,
} from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FileSelectionsService } from '../services/file-selections.service';
import { TranslateService, NgxTolgeeModule } from '@tolgee/ngx';
import { NgClass } from '@angular/common';
import { MatRipple } from '@angular/material/core';
import { MatIcon } from '@angular/material/icon';

@Component({
	selector: 'files-toolbar',
	templateUrl: './files-toolbar.component.html',
	styleUrls: ['./files-toolbar.component.scss'],
	imports: [NgClass, MatRipple, MatIcon, NgxTolgeeModule],
})
export class FilesToolbarComponent implements OnInit, OnDestroy {
	private readonly fileSelectionsService = inject(FileSelectionsService);
	private readonly translateService = inject(TranslateService);
	private destroy$: Subject<void> = new Subject<void>();
	selections$: Observable<string[]>;
	counterMessage: string;

	@Input() delegateClear = false;
	@Input() set selections(selections: number) {
		this.counterMessage = this.generateCounterMessageText(selections);
	}

	@Input() useSelectionService = true;
	@Input() relatedFilesSelected = false;
	@Input() loadedSelection = false;

	@Output() linkToEntityPressed = new EventEmitter<void>();
	@Output() deletePressed = new EventEmitter<void>();
	@Output() clearPressed = new EventEmitter<void>();

	ngOnInit() {
		if (this.useSelectionService) {
			this.selections$ = this.fileSelectionsService.selections$.pipe(
				takeUntil(this.destroy$)
			);

			this.selections$.subscribe(selections => {
				this.counterMessage = this.generateCounterMessageText(selections.length);
			});
		}
	}

	private generateCounterMessageText(counter): string {
		return this.translateService.instant('files_selected', { count: counter });
	}

	delete() {
		if (!this.relatedFilesSelected) {
			this.deletePressed.emit();
		}
	}

	clear() {
		if (this.delegateClear) {
			this.clearPressed.emit();
		} else {
			this.fileSelectionsService.clearSelections();
		}
	}
	link() {
		if (this.relatedFilesSelected) {
			this.linkToEntityPressed.emit();
		}
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
